'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _Vas = require('../Vas');

var _Vas2 = _interopRequireDefault(_Vas);

require('../css/PagingTable.css');

var _Icon = require('./Icon');

var _Icon2 = _interopRequireDefault(_Icon);

var _PagingButton = require('./PagingButton');

var _PagingButton2 = _interopRequireDefault(_PagingButton);

var _SelectField = require('./SelectField');

var _SelectField2 = _interopRequireDefault(_SelectField);

var _Loading = require('./Loading');

var _Loading2 = _interopRequireDefault(_Loading);

var _Checkbox = require('./Checkbox');

var _Checkbox2 = _interopRequireDefault(_Checkbox);

var _ConfirmBox = require('./ConfirmBox');

var _ConfirmBox2 = _interopRequireDefault(_ConfirmBox);

var _utilsLib = require('utils-lib');

var _modelsLib = require('models-lib');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable array-callback-return */
/* eslint-disable react/jsx-key */
/* eslint-disable no-unused-vars */


/*
Pflichtproperties:
ref="table" 
SearchParamsStrings={searchParamsStrings} TableReference={this} DataBaseTable={"B2Zahlweise"} 
Selectable={true/false} 
Limit={this.state.Limit} Start={ this.state.Start } End={ this.state.End } Count={ this.state.Count } 
Columns={[]}
Keys={ [] } 
Data={ this.state.Data }
Add={true/false} AddClick={()=>{this.createPayment()}} 
Download={true/false} DownloadType={"Document"/"Verification"} Modus={"Abellio"/"DBBus"}
Search={true/false} 
CSV={true/false} CSVTableName={}
AppURL={Vas.ApplicationUrl} ApiURL={Vas.ApiUrl} ApiKey={Vas.ApiKey}
SelectFieldChooseText={Vas.Resources.Labels["PleaseChoose"]} 
TooltipSearchName={Vas.Resources.Tooltips["SearchName"]} TooltipCsvDownload={Vas.Resources.Tooltips["CsvDownload"]}
LabelPage={Vas.Resources.Labels["Page"]} LabelOf={Vas.Resources.Labels["Of"]} LabelCountPerPage={Vas.Resources.Labels["CountPerPage"]}

optional:
Border={true/false} 
Action={true/false} Actions={[{String:"", OnClick:(ids)=>{console.log(ids)} },{String:"",OnClick:(ids)=>{console.log(ids)}}]} 
                ActionLabel={[Vas.Resources.Labels["ActionConfirm"],Vas.Resources.Labels["ActionConfirm2"],Vas.Resources.Labels["ActionConfirm3"]]}
                LabelConfirm={Vas.Resources.Labels["Confirm"]} LabelCancel={Vas.Resources.Labels["Cancel"]}
                ActionFieldChooseText={Vas.Resources.Labels["ChooseAction"]}
*/
var moment = require('moment');
moment().format();

var PagingTable = function (_Component) {
  _inherits(PagingTable, _Component);

  //#region Komponente

  function PagingTable(props) {
    _classCallCheck(this, PagingTable);

    var _this = _possibleConstructorReturn(this, (PagingTable.__proto__ || Object.getPrototypeOf(PagingTable)).call(this, props));

    _this.state = {};
    _this.state.OrderDirection = "";
    _this.state.OrderColumn = "";
    _this.state.Data = [];
    _this.selectable = props.Selectable;
    _this.state.Add = _this.props.Add;
    _this.state.AddClick = _this.props.AddClick;
    _this.state.Edit = _this.props.Edit;
    _this.state.EditClick = _this.props.EditClick;
    _this.state.ActionButton = false;
    _this.state.Actions = _this.props.Actions; //Aktionen die durchgeführt werden können [{},{}]
    _this.state.Action = _this.props.Action; //soll eine oder mehrere Aktion durchgeführt werden? [true/false]
    _this.state.ActionLabel = _this.props.ActionLabel;
    _this.state.DataBaseTable = _this.props.DataBaseTable;
    _this.state.CSV = _this.props.CSV;
    _this.state.CSVTableName = _this.props.CSVTableName;
    _this.state.Download = _this.props.Download;
    _this.state.DownloadType = _this.props.DownloadType;
    _this.state.Filter = _this.props.Filter;
    _this.state.FilterColoumn = _this.props.FilterColoumn;
    _this.state.FilterDefault = _this.props.FilterDefault;
    _this.state.FilterData = _this.props.FilterData;
    _this.state.FilterText = _this.props.FilterText;
    _this.state.SelectFieldChooseText = _this.props.SelectFieldChooseText;
    _this.state.Delete = _this.props.Delete;
    _this.state.DeleteOnClick = _this.props.DeleteOnClick;
    _this.state.DeleteId = _this.props.DeleteId; //SpaltenID
    _this.state.DeleteValue = _this.props.DeleteValue;
    _this.state.SearchLimit = _this.props.SearchLimit;

    _this.state.Paging = _this.props.Paging !== null && _this.props.Paging !== undefined ? _this.props.Paging : true;

    _this.state.RowOnClick = _this.props.RowOnClick;
    _this.state.CWidth = _this.props.CWidth; //Spaltenbreiten
    _this.state.Border = _this.props.Border;

    //Der Standard ist hier true. Das heißt, das BurgerMenu wird hier mit anezeigt
    _this.state.UseBurgerMenu = _this.props.UseBurgerMenu !== undefined && _this.props.UseBurgerMenu !== null ? _this.props.UseBurgerMenu : true;

    _this.state.ShowAllOnOnePage = _this.props.ShowAllOnOnePage !== null && _this.props.ShowAllOnOnePage !== undefined ? _this.props.ShowAllOnOnePage : false;

    _this.state.ExtendShownResultsOnPage = _this.props.ExtendShownResultsOnPage !== null && _this.props.ExtendShownResultsOnPage !== undefined ? _this.props.ExtendShownResultsOnPage : false;

    if (props.SortColumns) {
      _this.state.SortColumns = props.SortColumns;
    } else {
      _this.state.SortColumns = [];
    }

    if (props.Columns) {
      _this.state.columns = props.Columns;
    } else {
      _this.state.columns = [];
    }

    if (props.Keys) {
      _this.state.keys = props.Keys;
    } else {
      _this.state.keys = [];
    }
    if (props.Data) {
      _this.state.Data = props.Data;
    }

    _this.state.Count = props.Count;
    _this.state.Limit = props.Limit ? props.Limit : 10;
    _this.state.Start = props.Start ? props.Start : 0;
    _this.state.End = props.End;
    _this.state.ParamCustomerCategory = props.ParamCustomerCategory;

    if (_this.props.SearchParamsDecimals) {
      _this.state.SearchParamsDecimals = _this.props.SearchParamsDecimals;
    }
    if (_this.props.SearchParamsStrings) {
      _this.state.SearchParamsStrings = _this.props.SearchParamsStrings;
    }
    if (_this.state.SearchParamsDateTimes) {
      _this.state.SearchParamsDateTimes = _this.props.SearchParamsDateTimes;
    }

    _this.state.SearchParams = _this.props.SearchParams;

    _this.state.Search = _this.props.Search;

    if (_this.props.SearchCol) {
      _this.state.SearchCol = _this.props.SearchCol;
    } else {
      _this.state.SearchCol = "";
    }

    _this.state.LabelPage = _this.props.LabelPage;

    _this.state.LossReport = _this.props.LossReport;
    _this.state.LossReportClick = _this.props.LossReportClick;

    _this.state.ContractCancel = _this.props.ContractCancel;
    _this.state.ContractCancelClick = _this.props.ContractCancelClick;

    _this.state.Id = _this.props.Id ? _this.props.Id : "table";

    _this.SearchParamsArray = [];
    _this.state.SearchParam = "Nachname";

    _this.state.IdColoumn = _this.props.IdColoumn;

    _this.state.CSVController = _this.props.CSVController;

    _this.Request = new _modelsLib.RequestAjaxClass(function (error) {
      _this.props.ErrorHandlingPage(error);
    }, null);
    _this.CsvModel = new _modelsLib.CsvModel([_this]);
    _this.DocumentsModel = new _modelsLib.DocumentsModel([_this]);
    _this.state.ShowIcons = _this.props.ShowIcons !== null && _this.props.ShowIcons !== undefined ? _this.props.ShowIcons : true;

    var kontrastNumber = localStorage.getItem('Kontrast');

    if (kontrastNumber == "true") {

      (0, _jquery2.default)(".pagingTable tbody tr, .pagingTableWithoutBorder tbody tr").mouseenter(function () {
        (0, _jquery2.default)(this).attr('style', 'background-color: #1d5c87 !important; border-bottom: 1px solid #1d5c87;');
      }).mouseleave(function () {
        (0, _jquery2.default)(this).attr('style', 'background-color: #ffffff !important; border-bottom: 1px solid #1d5c87;');
      });

      (0, _jquery2.default)(".selected").mouseenter(function () {
        (0, _jquery2.default)(this).attr('style', 'background-color: #1d5c87 !important; border-bottom: 1px solid #1d5c87;');
      }).mouseleave(function () {
        (0, _jquery2.default)(this).attr('style', 'background-color: #1d5c87 !important; border-bottom: 1px solid #1d5c87;');
      });
    } else if (kontrastNumber == "false") {
      (0, _jquery2.default)(".pagingTable tbody tr, .pagingTableWithoutBorder tbody tr").mouseenter(function () {
        (0, _jquery2.default)(this).attr('style', 'background-color: #3393d3 !important; border-bottom: 1px solid #3393d3;');
      }).mouseleave(function () {
        (0, _jquery2.default)(this).attr('style', 'background-color: #ffffff !important; border-bottom: 1px solid #3393d3;');
      });

      (0, _jquery2.default)(".selected").mouseenter(function () {
        (0, _jquery2.default)(this).attr('style', 'background-color: #3393d3 !important; border-bottom: 1px solid #3393d3;');
      }).mouseleave(function () {
        (0, _jquery2.default)(this).attr('style', 'background-color: #3393d3 !important; border-bottom: 1px solid #3393d3;');
      });
    }
    return _this;
  }

  _createClass(PagingTable, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.GetSearchParams();
      this.loadData();
      var me = this;

      (0, _jquery2.default)("#page").val(this.Page());

      /*$("#search").keypress(function(e) {
          if (e.which === 13)
          {
              me.Search();
          }
      });*/

      (0, _jquery2.default)("body").keydown(function (e) {
        if (e.which === 37) {
          me.Previous();
        }
        if (e.which === 39) {
          me.Next();
        }
      });

      this.Request.setAuth(true);
      this.Request.setApiKey(this.props.ApiKey);
      this.Request.setApiUrl(this.props.ApiURL);

      this.CsvModel.SetRequest(this.Request);
      this.DocumentsModel.SetRequest(this.Request);
    }
  }, {
    key: 'Update',
    value: function Update(observer) {
      var me = this;
      this.setState({}, function () {
        if (observer === "CsvData") {
          me.setState({ CsvData: me.CsvModel.CsvData }, function () {
            _utilsLib.CsvExport.CsvDownload(me.state.CsvData, me.state.CSVTableName, me.state.keys, me.state.columns);
            _reactDom2.default.unmountComponentAtNode(document.getElementById('popupContainer'));
          });
        } else if (observer === "DocumentById") {
          var dataDownload = me.state.Data;
          var name = '';
          for (var i = 0; i < dataDownload.length; i++) {
            if (dataDownload[i].Id === me.DocumentsModel.DocumentId) {
              name = dataDownload[i].FileName;
            }
          }
          switch (me.state.DownloadType) {
            case "Document":
              {
                for (var _i = 0; _i < dataDownload.length; _i++) {
                  if (dataDownload[_i].Id === me.DocumentsModel.DocumentId) {
                    name = dataDownload[_i].FileName;
                  }
                }
                var sampleArr = me.base64ToArrayBuffer(me.DocumentsModel.Documents[0], me)[0];
                me.saveByteArray(sampleArr, name);
                break;
              }
            case "Verification":
              {
                for (var _i2 = 0; _i2 < dataDownload.length; _i2++) {
                  if (dataDownload[_i2].Id === me.DocumentsModel.DocumentId) {
                    name = dataDownload[_i2].Name;
                  }
                }
                var result = me.base64ToArrayBuffer(me.DocumentsModel.Documents[0], me);

                var _sampleArr = result[0];
                var type = result[1];
                me.saveByteArray(_sampleArr, name + "." + type);
                break;
              }
            default:
              break;
          }
        }
      });
    }
  }, {
    key: 'GetSearchParams',
    value: function GetSearchParams() {
      //Abrufen der möglichen Suchparameter
      //#region Methode zum gegebenen Zeitpunkt anpassen

      var searchParamsArr = [];

      //TODO: Umstellen auf den Webserviceaufruf, wenn Methode implementiert wurde
      // $.ajax({
      //     dataType: 'json',
      //     async: false,
      //     url: Vas.ApiUrl +"/customers/searchparams",
      //     type: "GET",
      //     beforeSend: function (xhr) {
      //     xhr.setRequestHeader('accept-language', localStorage.getItem('vas_language'));
      //     xhr.setRequestHeader('x-sts-APIKey', Vas.ApiKey);
      //     xhr.setRequestHeader('authorization', localStorage.getItem('vas_token'));},
      //     success: function (data){
      //         if (data){
      //             if (data.Data){

      //                 data.Data.forEach(function(value){                                                
      //                     searchParamsArr.push({ Key:value.Id, Display:value.Description });
      //                 });
      //             }                    
      //         }                
      //     }
      // });

      for (var i = 0; i < this.state.keys.length; i++) {

        switch (this.state.keys[i]) {

          case "dateOfBirth":
          case "DateOfBirth":
            break;

          case "name2":
          case "Name2":
            searchParamsArr.push({ Key: "firstName", Display: this.state.columns[i] });
            break;

          case "name1":
          case "Name1":
            searchParamsArr.push({ Key: "lastName", Display: this.state.columns[i] });
            break;

          default:
            searchParamsArr.push({ Key: this.state.keys[i], Display: this.state.columns[i] });
            break;

        }

        //searchParamsArr.push({ Key: this.state.keys[i], Display: this.state.columns[i] });
      }

      // searchParamsArr.push({ Key: "lastName", Display: "Nachname" });
      // searchParamsArr.push({ Key: "firstName", Display: "Vorname" });        
      // searchParamsArr.push({ Key: "street", Display: "Straße" });
      // searchParamsArr.push({ Key: "postcode", Display: "PLZ" });
      // searchParamsArr.push({ Key: "city", Display: "Ort" });
      // searchParamsArr.push({ Key: "customerNumber", Display: "Kundennummer" });
      // searchParamsArr.push({ Key: "email", Display: "E-Mail-Adresse" });

      for (var _i3 = 0; _i3 < searchParamsArr.length; _i3++) {
        this.SearchParamsArray.push({ Key: searchParamsArr[_i3].Key, Display: searchParamsArr[_i3].Display });
      }

      //#endregion
    }
  }, {
    key: 'PrepareSendData',
    value: function PrepareSendData() {

      var limit = this.state.Paging === false ? 1000 : this.state.Limit;
      var searchParams = "?limit=" + limit + "&start=" + this.state.Start;

      if (this.state.OrderColumn) {
        searchParams += "&orderColumn=" + this.state.OrderColumn;
      }

      if (this.state.OrderDirection) {
        searchParams += "&orderDirection=" + this.state.OrderDirection;
      }

      if (this.state.ParamCustomerCategory) {
        searchParams += "&customerCategory=" + this.state.ParamCustomerCategory;
      }
      if (this.state.SearchParams) {
        for (var i = 0; i < this.state.SearchParams.length; i++) {
          var text = '';

          if (this.state.SearchParams[i].SearchValue !== "") {
            text += "&" + this.state.SearchParams[i].Parameter + "=" + this.state.SearchParams[i].SearchValue;
          }

          searchParams += text;
        }
      }
      return searchParams;
    }
  }, {
    key: 'loadData',
    value: function loadData() {
      var dataToSend = this.PrepareSendData();
      if (this.props.onLoad) {
        var res = {
          Paging: {
            Limit: this.state.Paging === false ? 1000 : this.state.Limit,
            Start: this.state.Start,
            OrderColumn: this.state.OrderColumn,
            OrderDirection: this.state.OrderDirection

          }
        };
        this.props.onLoad(this, res);
      } else {
        this.props.TableReference.load(dataToSend);
      }
    }
    //#endregion

    //#region CSV

  }, {
    key: 'PrepareSendDataCSV',
    value: function PrepareSendDataCSV(Params) {

      var searchParams = "?limit=" + this.state.Count + "&start=0";

      if (this.state.OrderColumn) {
        searchParams += "&orderColumn=" + this.state.OrderColumn;
      }

      if (this.state.OrderDirection) {
        searchParams += "&orderDirection=" + this.state.OrderDirection;
      }

      if (this.state.SearchParams) {
        for (var i = 0; i < this.state.SearchParams.length; i++) {
          var text = '';
          text += "&" + this.state.SearchParams[i].Parameter + "=" + this.state.SearchParams[i].SearchValue;
          searchParams += text;
        }
      }
      return searchParams;
    }
  }, {
    key: 'loadCSV',
    value: function loadCSV(sendData) {
      if (this.state.CSVController) {
        this.CsvModel.GetCsvData(this.state.CSVController, sendData);
      }
    }
  }, {
    key: 'downloadCsv',
    value: function downloadCsv(me) {

      if (this.state.ShowAllOnOnePage === true || this.state.ExtendShownResultsOnPage === true) {
        _utilsLib.CsvExport.CsvDownload(JSON.parse(localStorage.getItem("csvDataContent")), me.state.CSVTableName, me.state.keys, me.state.columns);
      } else {
        _reactDom2.default.render(_react2.default.createElement(_Loading2.default, { modal: true }), document.getElementById('popupContainer'));
        me.loadCSV(me.PrepareSendDataCSV(me.state.SearchParams), me);
      }
    }

    //#endregion

    //#region sortieren und suchen und CSV

  }, {
    key: 'Search',
    value: function Search() {
      var _this2 = this;

      this.state.SearchCol = (0, _jquery2.default)("#SearchParams").val();

      var val = (0, _jquery2.default)("#search").val();
      if (val.length > 2) {
        if (this.state.SearchLimit !== null && this.state.SearchLimit !== undefined) {
          this.setState({ SearchParams: [{ Parameter: this.state.SearchCol, SearchValue: val }], Start: 0, Limit: this.state.SearchLimit }, function () {
            return _this2.loadData();
          });
        } else {
          this.setState({ SearchParams: [{ Parameter: this.state.SearchCol, SearchValue: val }], Start: 0 }, function () {
            return _this2.loadData();
          });
        }
      } else {
        if (val.length === 0) {
          var sel = document.getElementById('Pagestable');
          var opt = sel.options[sel.selectedIndex];

          this.setState({ SearchParams: [{ Parameter: this.state.SearchCol, SearchValue: val }], Start: 0, Limit: opt.value, OrderColumn: '' }, function () {
            return _this2.loadData();
          });
        }
      }
    }
  }, {
    key: 'SetOrder',
    value: function SetOrder(col) {
      var _this3 = this;

      for (var i = 0; i < this.state.columns.length; i++) {
        if (this.state.columns[i] === col) {
          col = this.state.keys[i];
        }
      }

      var column = this.state.OrderColumn;
      var dir = this.state.OrderDirection;

      if (column === col) {
        if (!dir) {
          dir = 'asc';
        } else {
          if (dir === 'desc') {
            dir = 'asc';
          } else {
            dir = 'desc';
          }
        }
      } else {
        dir = 'asc';
      }

      var sort = '';

      var iconId = 'ColIconArea_' + col;

      this.setState({ OrderDirection: dir, OrderColumn: col, OrderIcon: sort }, function () {

        _this3.loadData();

        for (var _i4 = 0; _i4 < _this3.state.columns.length; _i4++) {
          if (document.getElementById('ColIconArea_' + _this3.state.keys[_i4])) {
            _reactDom2.default.unmountComponentAtNode(document.getElementById('ColIconArea_' + _this3.state.keys[_i4]));
          }
        }

        if (dir === 'asc') {
          _reactDom2.default.render(_react2.default.createElement(_Icon2.default, {
            Name: "ArrowUp",
            Size: 18,
            Color: "black" }), document.getElementById(iconId));
        } else {
          _reactDom2.default.render(_react2.default.createElement(_Icon2.default, {
            Name: "ArrowDown",
            Size: 18,
            Color: "black" }), document.getElementById(iconId));
        }
      });
    }

    //#endregion

    //#region Seite ändern  

  }, {
    key: 'FirstPage',
    value: function FirstPage() {
      var _this4 = this;

      var start = 0;
      var end = this.state.Limit;

      this.setState({ Start: start, End: end }, function () {
        _this4.loadData();
        (0, _jquery2.default)("#page").val(_this4.Page());
      });
    }
  }, {
    key: 'Previous',
    value: function Previous() {
      var _this5 = this;

      var start = 0;
      var end = 0;

      if (this.state.Start - this.state.Limit >= 0) {
        start = this.state.Start - this.state.Limit;

        if (start - this.state.Limit >= 0) {
          end = start + this.state.Limit;
        } else {
          end = this.state.Limit;
        }

        this.setState({ Start: start, End: end }, function () {
          _this5.loadData();
          (0, _jquery2.default)("#page").val(_this5.Page());
        });
      }
    }
  }, {
    key: 'Next',
    value: function Next() {
      var _this6 = this;

      var start = 0;
      var end = 0;

      if (this.state.Start + this.state.Limit < this.state.Count) {
        start = this.state.Start + this.state.Limit;

        if (start <= this.state.Count) {
          if (start + this.state.Limit <= this.state.Count) {
            end = start + this.state.Limit;
          } else {
            end = this.state.Count;
          }
        } else {
          end = this.state.Count;
        }

        this.setState({ Start: start, End: end }, function () {
          _this6.loadData();
          (0, _jquery2.default)("#page").val(_this6.Page());
        });
      }
    }
  }, {
    key: 'LastPage',
    value: function LastPage() {
      var _this7 = this;

      var start = 0;
      var end = 0;

      var mod = this.state.Count % this.state.Limit;
      if (mod > 0) {
        end = this.state.Count;
        start = end - mod;
      } else {
        end = this.state.Count;
        if (end > 0) {
          start = end - this.state.Limit;
        } else {
          start = 0;
        }
      }
      this.setState({ Start: start, End: end }, function () {
        _this7.loadData();
        (0, _jquery2.default)("#page").val(_this7.Page());
      });
    }
  }, {
    key: 'ChangePage',
    value: function ChangePage() {
      var _this8 = this;

      //ändere Seitenzhal durch Eingaben der neuen Seite
      var newPage = parseInt(document.getElementById('page').value, 10);
      if (newPage > this.PageCount()) {
        newPage = this.PageCount();
        document.getElementById('page').value = newPage;
      } else if (newPage < 1) {
        newPage = 1;
        document.getElementById('page').value = newPage;
      }

      var end = this.state.Limit * newPage;
      var start = end - this.state.Limit;

      if (isNaN(end) || isNaN(start)) {
        start = 0;
        end = this.state.Limit - 1;
        document.getElementById('page').value = 1;
      }

      this.setState({ Start: start, End: end }, function () {
        _this8.loadData();
        (0, _jquery2.default)("#page").val(_this8.Page());
      });
    }

    //#endregion

    //#region Eigenschaften Seiten

  }, {
    key: 'ChangeItemsPage',
    value: function ChangeItemsPage() {
      var _this9 = this;

      //Ändere die Anzahl der angezeigten Datensätze
      if ((0, _jquery2.default)("#Pages" + this.state.Id)[0].selectedIndex > 0) {
        // eslint-disable-next-line
        this.setState({ Limit: parseInt((0, _jquery2.default)("#Pages" + this.state.Id).val()) }, function () {
          var start = 0;
          var end = 0;

          if (start + _this9.state.Limit <= _this9.state.Count) {
            end = start + _this9.state.Limit;
          } else {
            end = _this9.state.Count;
          }

          _this9.setState({ Start: start, End: end }, function () {
            _this9.loadData();
            (0, _jquery2.default)("#page").val(_this9.Page());
          });
        });
      }
    }
  }, {
    key: 'Page',
    value: function Page() {
      //ermittle die aktuelle Seitenzahl
      var page = '';
      if (this.state.Count < this.state.Limit) {
        page = 1;
      } else {
        page = this.state.End / this.state.Limit;
        var str = page.toString();
        if (str.indexOf(".") > 0) {
          page = str.substring(0, str.indexOf("."));
        } else {
          page = str;
        }
        var mod = this.state.End % this.state.Limit;
        if (mod > 0) {
          page++;
        }
      }

      return page;
    }
  }, {
    key: 'PageCount',
    value: function PageCount() {
      // ermittele die Anzahl der Seiten
      var count = '';
      if (this.state.Count < this.state.Limit) {
        count = 1;
      } else {
        count = this.state.Count / this.state.Limit;
        var str = count.toString();
        if (str.indexOf(".") > 0) {
          count = str.substring(0, str.indexOf("."));
        } else {
          count = str;
        }
        var mod = this.state.Count % this.state.Limit;
        if (mod > 0) {
          count++;
        }
      }
      return parseInt(count, 10);
    }
    //#endregion

    //#region Download Dokument

  }, {
    key: 'Download',
    value: function Download(event, me) {
      var id = (0, _jquery2.default)(event.target).parent().parent().parent().parent().parent().parent().parent("tr")[0].id;
      this.SelectRow(id);

      this.DocumentsModel.GetDocumentById(id);
    }
  }, {
    key: 'base64ToArrayBuffer',
    value: function base64ToArrayBuffer(base64, me) {
      //https://stackoverflow.com/questions/35038884/download-file-from-bytes-in-javascript 10.07.18
      var binaryString = window.atob(base64);
      var binaryLen = binaryString.length;
      var bytes = new Uint8Array(binaryLen);
      for (var i = 0; i < binaryLen; i++) {
        var ascii = binaryString.charCodeAt(i);
        bytes[i] = ascii;
      }

      var bytes2 = [];
      for (var _i5 = 0; _i5 < bytes.length; _i5++) {
        // jetzt gehts auch im IE
        var byteString = bytes[_i5].toString(16);

        //add leading zero here when bytestring is digit
        if (byteString.length === 1) {
          byteString = "0" + byteString;
        }

        bytes2.push(byteString);
      }

      /*bytes.forEach((byte) => {// ging nicht im IE
          bytes2.push(byte.toString(16))
      })*/
      var hex = bytes2.join('').toUpperCase();

      var type = me.getMimetype(hex.substr(0, 8));

      return [bytes, type];
    }

    //download not working in firefox-->Lösung:https://stackoverflow.com/questions/27115748/download-attribute-not-working-in-firefox 23.07.2018

  }, {
    key: 'saveByteArray',
    value: function saveByteArray(byte, filename) {
      var blob = new Blob([byte]);
      if (window.navigator.msSaveOrOpenBlob) // https://github.com/mholt/PapaParse/issues/175 23.07.2018 IE hack; see http://msdn.microsoft.com/en-us/library/ie/hh779016.aspx
        {
          window.navigator.msSaveBlob(blob, filename);
        } else {
        var link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    }

    //https://medium.com/the-everyday-developer/detect-file-mime-type-using-magic-numbers-and-javascript-16bc513d4e1e 16.10.2018

  }, {
    key: 'getMimetype',
    value: function getMimetype(signature) {

      switch (signature) {
        case '89504E47':
          return 'png';
        case '47494638':
          return 'gif';
        case '425047FB':
          return 'bpg';
        case 'FFD8FFDB':
        case 'FFD8FFE0':
        case 'FFD8FFE1':
          return 'jpeg';
        case '25504446':
          return 'pdf';
        case '504B0304':
        case '504B0506':
          return 'docx';
        case 'D0CF11E0':
          return 'doc';
        case '49492A00':
        case '4D4D002A':
          return 'tif';

        default:
          switch (signature.substr(0, 4)) {
            case '424D':
              return 'bmp';
            default:
              return '';
          }
      }
    }
    //#endregion

    //#region Filter

  }, {
    key: 'filter',
    value: function filter() {
      var _this10 = this;

      var searchParams = [];

      if (this.state.SearchParams) {
        searchParams = this.state.SearchParams;
      }
      for (var _i6 = searchParams.length - 1; _i6 >= 0; _i6--) {
        if (searchParams[_i6].Parameter === this.state.FilterColoumn) {
          searchParams.splice(_i6, 1);
        }
      }

      for (var i = 0; i < searchParams.length; i++) {
        if ((0, _jquery2.default)("#search").val() === "") {
          searchParams.pop();
        }
      }

      if (document.getElementById('Filter').value !== "-1" && document.getElementById('Filter').value !== "Wählen") {
        var value = document.getElementById('Filter').value;
        if (value.substring(0, 1) === "[") {
          var values = value.substring(1, value.length - 1);
          var vals = values.split(',');
          for (var _i7 = 0; _i7 < vals.length; _i7++) {
            searchParams.push({ Parameter: this.state.FilterColoumn, SearchValue: vals[_i7] });
          }
        } else {
          searchParams.push({ Parameter: this.state.FilterColoumn, SearchValue: value });
        }
      }

      var sel = document.getElementById('Pagestable');
      var opt = sel.options[sel.selectedIndex];

      this.setState({ SearchParams: searchParams, Start: 0, Limit: (0, _jquery2.default)("#search").val() === "" ? opt.value : this.state.SearchLimit }, function () {
        _this10.FirstPage();
      });
    }
    //#endregion

    //#region Checkboxen

  }, {
    key: 'cbAllClick',
    value: function cbAllClick() {
      var cb = document.getElementsByClassName('checkbox');
      var value = document.getElementById('cbAll').checked;
      for (var i = 0; i < cb.length; i++) {
        cb[i].checked = value;
      }
      this.setState({ ActionButton: value });
    }
  }, {
    key: 'cbClick',
    value: function cbClick(d) {
      var value = document.getElementById("cb" + d["Id"]).checked;
      if (value === false) {
        document.getElementById('cbAll').checked = false;
      }
      var checked = false;
      var cb = document.getElementsByClassName('checkbox');
      for (var i = 0; i < cb.length; i++) {
        if (cb[i].checked === true) {
          checked = true;
        }
      }
      this.setState({ ActionButton: checked });
    }
  }, {
    key: 'showActions',
    value: function showActions() {
      (0, _jquery2.default)("#MenuItems").removeClass().addClass("Menu-items");
    }
  }, {
    key: 'hideActions',
    value: function hideActions() {
      if (this.state.ShowIcons === true) {
        (0, _jquery2.default)("#MenuItems").removeClass().addClass("Menu-items-notVisible");
      }
    }
    //#endregion

  }, {
    key: 'MouseOverCell',
    value: function MouseOverCell(text, value) {

      var kontrastNumber = localStorage.getItem('Kontrast');

      if (kontrastNumber == "true") {
        (0, _jquery2.default)('#Data > tr:nth-child(2n) > td > table > tbody > tr > td').attr('style', 'background-color: none; border-bottom: none;');
        (0, _jquery2.default)('#Data > tr > td > table > tbody > tr > td').attr('style', 'border-bottom: none;');
        (0, _jquery2.default)(".pagingTable tbody tr:nth-child(2n), .pagingTableWithoutBorder tbody tr:nth-child(2n)").mouseenter(function () {
          (0, _jquery2.default)(this).attr('style', 'background-color: #1d5c87 !important; border-bottom: 1px solid #1d5c87;');
        }).mouseleave(function () {
          (0, _jquery2.default)(this).attr('style', 'background-color: rgba(29, 92, 135, 0.1); border-bottom: 1px solid #1d5c87;');
        });

        (0, _jquery2.default)(".pagingTable tbody tr, .pagingTableWithoutBorder tbody tr").mouseenter(function () {
          (0, _jquery2.default)(this).attr('style', 'background-color: #1d5c87 !important; border-bottom: 1px solid #1d5c87;');
        });

        (0, _jquery2.default)(".selected").mouseenter(function () {
          (0, _jquery2.default)(this).attr('style', 'background-color: #1d5c87 !important; border-bottom: 1px solid #1d5c87;');
        }).mouseleave(function () {
          (0, _jquery2.default)(this).attr('style', 'background-color: #1d5c87 !important; border-bottom: 1px solid #1d5c87;');
        });
      } else if (kontrastNumber == "false") {
        (0, _jquery2.default)('#Data > tr:nth-child(2n) > td > table > tbody > tr > td').attr('style', 'background-color: none; border-bottom: none;');
        (0, _jquery2.default)('#Data > tr > td > table > tbody > tr > td').attr('style', 'border-bottom: none;');
        (0, _jquery2.default)(".pagingTable tbody tr:nth-child(2n), .pagingTableWithoutBorder tbody tr:nth-child(2n)").mouseenter(function () {
          (0, _jquery2.default)(this).attr('style', 'background-color: #3393d3 !important; border-bottom: 1px solid #3393d3;');
        }).mouseleave(function () {
          (0, _jquery2.default)(this).attr('style', 'background-color: rgba(51, 147, 211, 0.1); border-bottom: 1px solid #3393d3;');
        });

        (0, _jquery2.default)(".pagingTable tbody tr, .pagingTableWithoutBorder tbody tr").mouseenter(function () {
          (0, _jquery2.default)(this).attr('style', 'background-color: #3393d3 !important; border-bottom: 1px solid #3393d3;');
        });

        (0, _jquery2.default)(".selected").mouseenter(function () {
          (0, _jquery2.default)(this).attr('style', 'background-color: #3393d3 !important; border-bottom: 1px solid #3393d3;');
        }).mouseleave(function () {
          (0, _jquery2.default)(this).attr('style', 'background-color: #3393d3 !important; border-bottom: 1px solid #1d5c87;');
        });
      }

      if (value) {
        if (value.length > 0) {
          if (document.getElementById(text)) {
            document.getElementById(text).classList.remove('CellComment');
            document.getElementById(text).classList.add('CellCommentVisible');
          }
          if (document.getElementById("td" + text)) {
            document.getElementById("td" + text).style.overflow = 'visible';
          }
        }
      }
    }
  }, {
    key: 'MouseLeaveCell',
    value: function MouseLeaveCell(text) {

      var kontrastNumber = localStorage.getItem('Kontrast');

      if (kontrastNumber == "true") {
        (0, _jquery2.default)('#Data > tr:nth-child(2n) > td > table > tbody > tr > td').attr('style', 'background-color: none; border-bottom: none;');
        (0, _jquery2.default)('#Data > tr > td > table > tbody > tr > td').attr('style', 'border-bottom: none;');
        (0, _jquery2.default)(".pagingTable tbody tr:nth-child(2n), .pagingTableWithoutBorder tbody tr:nth-child(2n)").mouseenter(function () {
          (0, _jquery2.default)(this).attr('style', 'background-color: #1d5c87 !important; border-bottom: 1px solid #1d5c87;');
        }).mouseleave(function () {
          (0, _jquery2.default)(this).attr('style', 'background-color: rgba(29, 92, 135, 0.1); border-bottom: 1px solid #1d5c87;');
        });

        (0, _jquery2.default)(".pagingTable tbody tr, .pagingTableWithoutBorder tbody tr").mouseleave(function () {
          (0, _jquery2.default)(this).attr('style', 'background-color: #ffffff !important; border-bottom: 1px solid #1d5c87;');
        });
        (0, _jquery2.default)(".pagingTable tbody tr:nth-child(2n), .pagingTableWithoutBorder tbody tr").mouseleave(function () {
          (0, _jquery2.default)(this).attr('style', 'background-color: none !important; border-bottom: 1px solid #1d5c87;');
        });

        (0, _jquery2.default)(".selected").mouseleave(function () {
          (0, _jquery2.default)(this).attr('style', 'background-color: #1d5c87 !important; border-bottom: 1px solid #1d5c87;');
        });
      } else if (kontrastNumber == "false") {
        (0, _jquery2.default)('#Data > tr:nth-child(2n) > td > table > tbody > tr > td').attr('style', 'background-color: none; border-bottom: none;');
        (0, _jquery2.default)('#Data > tr > td > table > tbody > tr > td').attr('style', 'border-bottom: none;');
        (0, _jquery2.default)(".pagingTable tbody tr:nth-child(2n), .pagingTableWithoutBorder tbody tr:nth-child(2n)").mouseenter(function () {
          (0, _jquery2.default)(this).attr('style', 'background-color: #3393d3 !important; border-bottom: 1px solid #3393d3;');
        }).mouseleave(function () {
          (0, _jquery2.default)(this).attr('style', 'background-color: rgba(51, 147, 211, 0.1); border-bottom: 1px solid #3393d3;');
        });

        (0, _jquery2.default)(".pagingTable tbody tr, .pagingTableWithoutBorder tbody tr").mouseleave(function () {
          (0, _jquery2.default)(this).attr('style', 'background-color: #ffffff !important; border-bottom: 1px solid #3393d3;');
        });
        (0, _jquery2.default)(".pagingTable tbody tr:nth-child(2n), .pagingTableWithoutBorder tbody tr").mouseleave(function () {
          (0, _jquery2.default)(this).attr('style', 'background-color: none !important; border-bottom: 1px solid #3393d3;');
        });

        (0, _jquery2.default)(".selected").mouseleave(function () {
          (0, _jquery2.default)(this).attr('style', 'background-color: #3393d3 !important; border-bottom: 1px solid #3393d3;');
        });
      }

      if (document.getElementById(text)) {
        document.getElementById(text).classList.remove('CellCommentVisible');
        document.getElementById(text).classList.add('CellComment');
      }

      if (document.getElementById("td" + text)) {
        document.getElementById("td" + text).style.overflow = 'hidden';
      }
    }
  }, {
    key: 'Click',
    value: function Click(rowId) {
      this.SelectRow(rowId);
      if (this.state.RowOnClick) {
        this.state.RowOnClick(rowId);
      }

      var kontrastNumber = localStorage.getItem('Kontrast');

      if (kontrastNumber == "true") {
        (0, _jquery2.default)('#btoChoose').attr('style', 'background-color: #1d5c87; width: 100px;');
      } else if (kontrastNumber == "false") {
        (0, _jquery2.default)('#btoChoose').attr('style', 'background-color: #3393d3; width: 100px;');
      }
    }
  }, {
    key: 'SelectRow',
    value: function SelectRow(rowId) {
      var elem = document.getElementsByClassName('selected');
      for (var i = 0; i < elem.length; i++) {
        elem[i].classList.remove('selected');
      }
      document.getElementById(rowId).classList.add('selected');
    }
  }, {
    key: 'LogoClick',
    value: function LogoClick() {
      if (kontrastNumber == "true") {
        (0, _jquery2.default)('#Data > tr:nth-child(2n) > td > table > tbody > tr > td').attr('style', 'background-color: none; border-bottom: none;');
        (0, _jquery2.default)('#Data > tr > td > table > tbody > tr > td').attr('style', 'border-bottom: none;');
        (0, _jquery2.default)('.pagingTable tbody td, .pagingTableWithoutBorder tbody td').attr('style', 'border-bottom: 1px solid #1d5c87;');
        (0, _jquery2.default)(".pagingTable tbody tr, .pagingTableWithoutBorder tbody tr").mouseenter(function () {
          (0, _jquery2.default)(this).attr('style', 'background-color: #1d5c87 !important; border-bottom: 1px solid #1d5c87;');
        }).mouseleave(function () {
          (0, _jquery2.default)(this).attr('style', 'background-color: #ffffff !important; border-bottom: 1px solid #1d5c87;');
        });

        (0, _jquery2.default)(".selected").mouseenter(function () {
          (0, _jquery2.default)(this).attr('style', 'background-color: #1d5c87 !important; border-bottom: 1px solid #1d5c87;');
        }).mouseleave(function () {
          (0, _jquery2.default)(this).attr('style', 'background-color: #1d5c87 !important; border-bottom: 1px solid #1d5c87;');
        });

        (0, _jquery2.default)('.extendedButton, .pagingButton, .pagingButtonPicker').attr('style', 'background-color: #1d5c87; width: 30px; height: 30px;');
        (0, _jquery2.default)('.page').attr('style', 'width: 25px; margin-right: 5px; text-align: center; border: 1px solid #1d5c87;');

        (0, _jquery2.default)('.datefield, .textfield, .emailfield, .numfield, .selectField').attr('style', 'width: 103px; border-bottom: 1px dotted #1d5c87;');
        (0, _jquery2.default)('#addressDetails .datefield, #addressDetails .textfield, #addressDetails .emailfield, #addressDetails .numfield, #addressDetails .selectField').attr('style', 'border-bottom: 1px dotted #1d5c87;');

        (0, _jquery2.default)('.customerDataContainerEditButtonNoIconsAdditionalAddressEdit > div:nth-child(1) > div:nth-child(1) > table:nth-child(1) > tbody:nth-child(1) > tr:nth-child(1) > td:nth-child(2) > div:nth-child(1) > button:nth-child(1)').attr('style', 'background-color: #1d5c87; width: 100px;');
      } else {
        (0, _jquery2.default)('#Data > tr:nth-child(2n) > td > table > tbody > tr > td').attr('style', 'background-color: none; border-bottom: none;');
        (0, _jquery2.default)('#Data > tr > td > table > tbody > tr > td').attr('style', 'border-bottom: none;');
        (0, _jquery2.default)('.pagingTable tbody td, .pagingTableWithoutBorder tbody td').attr('style', 'border-bottom: 1px solid #3393d3;');
        (0, _jquery2.default)(".pagingTable tbody tr, .pagingTableWithoutBorder tbody tr").mouseenter(function () {
          (0, _jquery2.default)(this).attr('style', 'background-color: #3393d3 !important; border-bottom: 1px solid #3393d3;');
        }).mouseleave(function () {
          (0, _jquery2.default)(this).attr('style', 'background-color: #ffffff !important; border-bottom: 1px solid #3393d3;');
        });

        (0, _jquery2.default)(".selected").mouseenter(function () {
          (0, _jquery2.default)(this).attr('style', 'background-color: #3393d3 !important; border-bottom: 1px solid #3393d3;');
        }).mouseleave(function () {
          (0, _jquery2.default)(this).attr('style', 'background-color: #3393d3 !important; border-bottom: 1px solid #3393d3;');
        });

        (0, _jquery2.default)('.extendedButton, .pagingButton, .pagingButtonPicker').attr('style', 'background-color: #3393d3; width: 30px; height: 30px;');
        (0, _jquery2.default)('.page').attr('style', 'width: 25px; margin-right: 5px; text-align: center; border: 1px solid #3393d3;');

        (0, _jquery2.default)('.datefield, .textfield, .emailfield, .numfield, .selectField').attr('style', 'width: 103px; border-bottom: 1px dotted #3393d3;');

        (0, _jquery2.default)('.customerDataContainerEditButtonNoIconsAdditionalAddressEdit > div:nth-child(1) > div:nth-child(1) > table:nth-child(1) > tbody:nth-child(1) > tr:nth-child(1) > td:nth-child(2) > div:nth-child(1) > button:nth-child(1)').attr('style', 'background-color: #3393d3; width: 100px;');
      }
    }
  }, {
    key: 'FontSizeClick',
    value: function FontSizeClick() {
      var schriftgröße = localStorage.getItem('Schriftgröße');

      //Schriftgröße bei Klick in 2er Schritten erhöhen
      //$('#customerCardHeadline').removeClass("Schriftgröße_22").addClass("Schriftgröße_17");

      if (schriftgröße != null) {

        switch (schriftgröße) {
          case "0":
            (0, _jquery2.default)('#addressDetails .selectField').attr("style", "font-size: 19px;");
            (0, _jquery2.default)('#Zip').attr("style", "font-size: 19px;");
            (0, _jquery2.default)('#City').attr("style", "font-size: 19px;");
            (0, _jquery2.default)('#Street').attr("style", "font-size: 19px;");
            (0, _jquery2.default)('#HouseNumber').attr("style", "font-size: 19px;");
            (0, _jquery2.default)('#HouseNumberAddition').attr("style", "font-size: 19px;");
            break;
          case "1":
            (0, _jquery2.default)('#addressDetails .selectField').attr("style", "font-size: 14px;");
            (0, _jquery2.default)('#Zip').attr("style", "font-size: 14px;");
            (0, _jquery2.default)('#City').attr("style", "font-size: 14px;");
            (0, _jquery2.default)('#Street').attr("style", "font-size: 14px;");
            (0, _jquery2.default)('#HouseNumber').attr("style", "font-size: 14px;");
            (0, _jquery2.default)('#HouseNumberAddition').attr("style", "font-size: 14px;");
            break;
          case "2":
            (0, _jquery2.default)('#addressDetails .selectField').attr("style", "font-size: 15px;");
            (0, _jquery2.default)('#Zip').attr("style", "font-size: 15px;");
            (0, _jquery2.default)('#City').attr("style", "font-size: 15px;");
            (0, _jquery2.default)('#Street').attr("style", "font-size: 15px;");
            (0, _jquery2.default)('#HouseNumber').attr("style", "font-size: 15px;");
            (0, _jquery2.default)('#HouseNumberAddition').attr("style", "font-size: 15px;");
            break;
          case "3":
            (0, _jquery2.default)('#addressDetails .selectField').attr("style", "font-size: 16px;");
            (0, _jquery2.default)('#Zip').attr("style", "font-size: 16px;");
            (0, _jquery2.default)('#City').attr("style", "font-size: 16px;");
            (0, _jquery2.default)('#Street').attr("style", "font-size: 16px;");
            (0, _jquery2.default)('#HouseNumber').attr("style", "font-size: 16px;");
            (0, _jquery2.default)('#HouseNumberAddition').attr("style", "font-size: 16px;");
            break;
          case "4":
            (0, _jquery2.default)('#addressDetails .selectField').attr("style", "font-size: 17px;");
            (0, _jquery2.default)('#Zip').attr("style", "font-size: 17px;");
            (0, _jquery2.default)('#City').attr("style", "font-size: 17px;");
            (0, _jquery2.default)('#Street').attr("style", "font-size: 17px;");
            (0, _jquery2.default)('#HouseNumber').attr("style", "font-size: 17px;");
            (0, _jquery2.default)('#HouseNumberAddition').attr("style", "font-size: 17px;");
            break;
          case "5":
            (0, _jquery2.default)('#addressDetails .selectField').attr("style", "font-size: 18px;");
            (0, _jquery2.default)('#Zip').attr("style", "font-size: 18px;");
            (0, _jquery2.default)('#City').attr("style", "font-size: 18px;");
            (0, _jquery2.default)('#Street').attr("style", "font-size: 18px;");
            (0, _jquery2.default)('#HouseNumber').attr("style", "font-size: 18px;");
            (0, _jquery2.default)('#HouseNumberAddition').attr("style", "font-size: 18px;");
            break;
        }
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this11 = this;

      var kontrastNumber = localStorage.getItem('Kontrast');

      if (kontrastNumber == "true") {
        (0, _jquery2.default)('#Data > tr:nth-child(2n) > td > table > tbody > tr > td').attr('style', 'background-color: none; border-bottom: none;');
        (0, _jquery2.default)('#Data > tr > td > table > tbody > tr > td').attr('style', 'border-bottom: none;');
        (0, _jquery2.default)('.pagingTable tbody td, .pagingTableWithoutBorder tbody td').attr('style', 'border-bottom: 1px solid #1d5c87;');
        (0, _jquery2.default)(".pagingTable tbody tr, .pagingTableWithoutBorder tbody tr").mouseenter(function () {
          (0, _jquery2.default)(this).attr('style', 'background-color: #1d5c87 !important; border-bottom: 1px solid #1d5c87;');
        }).mouseleave(function () {
          (0, _jquery2.default)(this).attr('style', 'background-color: #ffffff !important; border-bottom: 1px solid #1d5c87;');
        });

        (0, _jquery2.default)(".selected").mouseenter(function () {
          (0, _jquery2.default)(this).attr('style', 'background-color: #1d5c87 !important; border-bottom: 1px solid #1d5c87;');
        }).mouseleave(function () {
          (0, _jquery2.default)(this).attr('style', 'background-color: #1d5c87 !important; border-bottom: 1px solid #1d5c87;');
        });

        (0, _jquery2.default)('.extendedButton, .pagingButton, .pagingButtonPicker').attr('style', 'background-color: #1d5c87; width: 30px; height: 30px;');
        (0, _jquery2.default)('.page').attr('style', 'width: 25px; margin-right: 5px; text-align: center; border: 1px solid #1d5c87;');

        (0, _jquery2.default)('.datefield, .textfield, .emailfield, .numfield, .selectField').attr('style', 'width: 103px; border-bottom: 1px dotted #1d5c87;');
        (0, _jquery2.default)('#addressDetails .datefield, #addressDetails .textfield, #addressDetails .emailfield, #addressDetails .numfield, #addressDetails .selectField').attr('style', 'border-bottom: 1px dotted #1d5c87;');

        (0, _jquery2.default)('.customerDataContainerEditButtonNoIconsAdditionalAddressEdit > div:nth-child(1) > div:nth-child(1) > table:nth-child(1) > tbody:nth-child(1) > tr:nth-child(1) > td:nth-child(2) > div:nth-child(1) > button:nth-child(1)').attr('style', 'background-color: #1d5c87; width: 100px;');
      } else if (kontrastNumber == "false") {
        (0, _jquery2.default)('#Data > tr:nth-child(2n) > td > table > tbody > tr > td').attr('style', 'background-color: none; border-bottom: none;');
        (0, _jquery2.default)('#Data > tr > td > table > tbody > tr > td').attr('style', 'border-bottom: none;');
        (0, _jquery2.default)('.pagingTable tbody td, .pagingTableWithoutBorder tbody td').attr('style', 'border-bottom: 1px solid #3393d3;');
        (0, _jquery2.default)(".pagingTable tbody tr, .pagingTableWithoutBorder tbody tr").mouseenter(function () {
          (0, _jquery2.default)(this).attr('style', 'background-color: #3393d3 !important; border-bottom: 1px solid #3393d3;');
        }).mouseleave(function () {
          (0, _jquery2.default)(this).attr('style', 'background-color: #ffffff !important; border-bottom: 1px solid #3393d3;');
        });

        (0, _jquery2.default)(".selected").mouseenter(function () {
          (0, _jquery2.default)(this).attr('style', 'background-color: #3393d3 !important; border-bottom: 1px solid #3393d3;');
        }).mouseleave(function () {
          (0, _jquery2.default)(this).attr('style', 'background-color: #3393d3 !important; border-bottom: 1px solid #3393d3;');
        });

        (0, _jquery2.default)('.extendedButton, .pagingButton, .pagingButtonPicker').attr('style', 'background-color: #3393d3; width: 30px; height: 30px;');
        (0, _jquery2.default)('.page').attr('style', 'width: 25px; margin-right: 5px; text-align: center; border: 1px solid #3393d3;');

        (0, _jquery2.default)('.datefield, .textfield, .emailfield, .numfield, .selectField').attr('style', 'width: 103px; border-bottom: 1px dotted #3393d3;');

        (0, _jquery2.default)('.customerDataContainerEditButtonNoIconsAdditionalAddressEdit > div:nth-child(1) > div:nth-child(1) > table:nth-child(1) > tbody:nth-child(1) > tr:nth-child(1) > td:nth-child(2) > div:nth-child(1) > button:nth-child(1)').attr('style', 'background-color: #3393d3; width: 100px;');
      }

      //#region Suchen und selectieren
      var columnCount = 0;
      if (this.state.columns) {
        columnCount = this.state.columns.length;
      }

      var Tooltip = _react2.default.createElement(
        'span',
        null,
        this.props.TooltipSearchName
      );

      if (this.selectable) {
        columnCount += 1;
      }
      //#endregion

      //#region Features


      var csv = '';
      if (this.state.CSV === true) {
        //csv = <PagingButton Width={30} onClick={()=>{ this.downloadCsv(this)}} text={<Icon AppURL={this.props.AppURL} Name={"Download"} Size={18} Color={"white"} Align={"left"} PaddingLeft={'6px'} PaddingTop={'1px'} />} Type={"Picker"} Tooltip={this.props.TooltipCsvDownload}/> 
        csv = { String: "Download (CSV)", OnClick: function OnClick() {
            _this11.downloadCsv(_this11);
          } };
      }

      var add = '';
      if (this.state.Add === true) {
        //add=<ExtendedButton Usable={true} Id={"Add"} Float={'left'} Width={32} Height={32} Type={"Round"} Text={<Icon AppURL={this.props.AppURL} Name={"Add"} Size={18} Color={"black"} Align={"left"} PaddingRight={'5px'} PaddingLeft={'6px'} PaddingTop={'1px'}/>}  OnClick={this.props.AddClick}/>;

        var addString = 'Hinzufügen';

        if (this.props.AddString !== undefined) {
          addString = this.props.AddString;
        }

        add = { String: addString, OnClick: this.state.AddClick };
      }

      var edit = '';
      if (this.state.Edit === true) {

        var editString = 'Bearbeiten';

        if (this.props.EditString !== undefined) {
          editString = this.props.EditString;
        }

        edit = { String: editString, OnClick: this.state.EditClick };
      }

      var filter = '';
      if (this.state.Filter === true) {
        filter = _react2.default.createElement(_SelectField2.default, {
          AppURL: this.props.AppURL,
          Id: "Filter",
          Default: this.state.FilterDefault,
          Label: this.state.FilterText,
          Data: this.state.FilterData,
          SelectFieldChooseText: this.state.SelectFieldChooseText,
          OnChange: function OnChange() {
            _this11.filter(1);
          } });
      }

      var filter2 = '';
      if (this.state.Filter2 === true) {
        filter2 = _react2.default.createElement(_SelectField2.default, {
          AppURL: this.props.AppURL,
          Id: "Filter2",
          Float: 'left',
          Default: this.state.FilterDefault2,
          Label: this.state.FilterText2,
          Data: this.state.FilterData2,
          SelectFieldChooseText: this.state.SelectFieldChooseText,
          OnChange: function OnChange() {
            _this11.filter(2);
          } });
      }

      var standart = [add, edit, csv];
      var menue = '';
      var classNameMenuItems = 'Menu-items-notVisible';
      if (this.state.ShowIcons === false) {
        classNameMenuItems = 'Menu-items';
      }

      var burgerMenue = '';

      if (this.state.UseBurgerMenu) {
        burgerMenue = _react2.default.createElement(_Icon2.default, {
          Name: "Menu",
          Color: "black",
          Size: 24
        });
      }

      if (this.state.ActionButton === true) {

        menue = _react2.default.createElement(
          'div',
          {
            onMouseOver: function onMouseOver() {
              _this11.showActions();
            },
            onMouseLeave: function onMouseLeave() {
              _this11.hideActions();
            } },
          _react2.default.createElement(
            'div',
            { style: { float: 'right' } },
            burgerMenue,
            _react2.default.createElement(
              'div',
              {
                id: 'MenuItems',
                className: 'Menu-items-notVisible' },
              this.state.Actions.map(function (m) {

                var additionalIidString = m.String;

                if (m.String == "Download (CSV)") {
                  additionalIidString = "Download_CSV";
                }

                return _react2.default.createElement(
                  'div',
                  {
                    id: "MenuItem_" + additionalIidString,
                    onClick: function onClick() {
                      var ids = [];
                      var cb = document.getElementsByClassName('checkbox');
                      for (var i = 0; i < cb.length; i++) {
                        if (cb[i].checked === true) {
                          if (cb[i].id !== "cbAll") {
                            ids.push(cb[i].id);
                          }
                        }
                      }
                      var txt = _this11.state.ActionLabel[0] + " \"" + m.String + "\" " + _this11.state.ActionLabel[1] + " " + ids.length + " " + _this11.state.ActionLabel[2];
                      _reactDom2.default.render(_react2.default.createElement(_ConfirmBox2.default, {
                        AppURL: _this11.props.AppURL,
                        modal: false,
                        MessageText: txt,
                        Click: function Click() {
                          m.OnClick(ids);
                        },
                        LabelConfirm: _this11.props.LabelConfirm,
                        LabelCancel: _this11.props.LabelCancel }), document.getElementById('messageContainer'));
                    } },
                  m.String
                );
              })
            )
          )
        );
      } else {
        if (typeof standart[0] !== "string" || typeof standart[1] !== "string" || typeof standart[2] !== "string") {

          menue = _react2.default.createElement(
            'div',
            {
              onMouseOver: function onMouseOver() {
                _this11.showActions();
              },
              onMouseLeave: function onMouseLeave() {
                _this11.hideActions();
              } },
            _react2.default.createElement(
              'div',
              { style: { float: 'right', position: 'relative' } },
              burgerMenue,
              _react2.default.createElement(
                'div',
                {
                  id: 'MenuItems',
                  className: classNameMenuItems },
                standart.map(function (m) {
                  if (m !== '') {

                    var additionalIidString = m.String;

                    if (m.String == "Download (CSV)") {
                      additionalIidString = "Download_CSV";
                    }

                    return _react2.default.createElement(
                      'div',
                      { id: "MenuItem_" + additionalIidString, onClick: function onClick() {
                          m.OnClick();
                        } },
                      m.String
                    );
                  }
                })
              )
            )
          );
        }
      }

      //#endregion

      //#region table
      var actionAll = '';
      var widthAction = 0;
      if (this.state.Action === true) {
        actionAll = _react2.default.createElement(_Checkbox2.default, {
          Id: "cbAll",
          Float: 'center',
          onClick: function onClick() {
            _this11.cbAllClick();
          } });

        widthAction = 70;
      }

      var col = '';
      if (this.state.keys) {
        for (var i = 0; i < this.state.keys.length; i++) {
          if (this.state.keys[i] === this.state.OrderColumn) {
            col = this.state.columns[i];
          }
        }
      }

      var widthButtons = 0;
      var maxWidthButtons = 0;

      var dataSet = this.state.Data.map(function (d) {

        var download = '';
        if (_this11.state.Download === true) {
          download = _react2.default.createElement(_Icon2.default, {
            AppURL: _this11.props.AppURL,
            Name: "Download",
            Size: 24,
            Color: "green",
            Align: "left",
            OnClick: function OnClick(e) {
              _this11.Download(e, _this11);
            },
            Title: _Vas2.default.getText("Tooltips", "Download"),
            Id: d.Id
          });
        }

        var del = '';
        if (_this11.state.Delete === true) {
          del = _react2.default.createElement(_Icon2.default, {
            AppURL: _this11.props.AppURL,
            Name: "Delete",
            Size: 24,
            Color: "black",
            Align: "left",
            OnClick: _this11.state.DeleteOnClick,
            Title: _Vas2.default.getText("Tooltips", "Delete"),
            Id: d.Id
          });
        }

        var action = null;
        if (_this11.state.Action === true) {
          action = _react2.default.createElement(_Checkbox2.default, {
            Id: "cb" + d["Id"],
            onClick: function onClick(e) {
              _this11.cbClick(d);
            } });
        }

        var lossReport = '';
        var contractCancel = '';

        if (_this11.props.Right) {
          if (_this11.props.Right.Delete) {
            if (_this11.props.Right.Delete === true) {
              if (d.StatusId === 1 && _utilsLib.DateTimeHelper.StringToDate(d.DateTo, true, localStorage.getItem('vas_language')).isSameOrAfter(moment())) {
                if (_this11.state.ContractCancel === true) {
                  contractCancel = _react2.default.createElement(_Icon2.default, {
                    Name: "Delete",
                    Size: 24,
                    Color: "black",
                    Align: "left",
                    PaddingRight: '5px',
                    PaddingLeft: '6px',
                    PaddingTop: '1px',
                    OnClick: _this11.state.ContractCancelClick });
                }
                if (_this11.state.LossReport === true) {
                  lossReport = _react2.default.createElement(_Icon2.default, {
                    Name: "Lost",
                    Size: 24,
                    Color: "black",
                    Align: "left",
                    PaddingRight: '5px',
                    PaddingLeft: '6px',
                    PaddingTop: '1px',
                    OnClick: _this11.state.LossReportClick });
                }
              }
            }
          }
        }

        var buttons = [];
        widthButtons = 0;

        if (lossReport !== '') {
          buttons.push(_react2.default.createElement(
            'td',
            { style: { float: 'left' }, key: "loss" },
            lossReport
          ));
          widthButtons += 45;
        }

        if (contractCancel !== '') {
          buttons.push(_react2.default.createElement(
            'td',
            { style: { float: 'left' }, key: "cancel" },
            contractCancel
          ));
          widthButtons += 45;
        }

        if ((typeof del === 'undefined' ? 'undefined' : _typeof(del)) === "object") {
          widthButtons += 45;
        }
        if (widthButtons > maxWidthButtons) {
          maxWidthButtons = widthButtons;
        }

        var IdColoumn = "Id";
        if (_this11.state.IdColoumn) {
          IdColoumn = _this11.state.IdColoumn;
        }

        if (_this11.state.Delete === true) {

          if (download !== '') {
            if (d[IdColoumn].substring(0, 10) != 'NoDocument') {
              buttons.push(_react2.default.createElement(
                'td',
                { style: { float: 'left' }, key: "download" },
                download
              ));
            } else {
              buttons.push(_react2.default.createElement('td', null));
            }
            widthButtons += 45;
          }

          var _i8 = 0;
          if (_this11.state.DeleteId) {
            if (d[_this11.state.DeleteId] === _this11.state.DeleteValue) {
              var actionCol = null;
              var _j = -1;
              if (action !== null) {
                actionCol = _react2.default.createElement(
                  'td',
                  null,
                  action
                );
              }
              var buttonsCol = '';
              if (buttons.length > 0 || (typeof del === 'undefined' ? 'undefined' : _typeof(del)) === "object") {
                buttonsCol = _react2.default.createElement(
                  'td',
                  {
                    className: "actionsButtons",
                    style: { 'width': widthButtons + "px" } },
                  _react2.default.createElement(
                    'table',
                    null,
                    _react2.default.createElement(
                      'tbody',
                      null,
                      _react2.default.createElement(
                        'tr',
                        {
                          onClick: function onClick() {
                            _this11.SelectRow(d[IdColoumn]);
                          },
                          key: 1 },
                        buttons,
                        _react2.default.createElement(
                          'td',
                          { key: "del" },
                          del
                        )
                      )
                    )
                  )
                );
              }
              return _react2.default.createElement(
                'tr',
                { id: d[IdColoumn] },
                actionCol,
                _this11.state.keys.map(function (k) {
                  var inhalt = d[k];
                  if (!d[k]) {
                    inhalt = _i8;
                    _i8++;
                  }

                  _j++;

                  return _react2.default.createElement(
                    'td',
                    {
                      id: "td" + d[IdColoumn] + inhalt,
                      key: k
                      // data-label={this.state.columns[j]}
                      , className: "pagingTableCell visibleTableContent",
                      onMouseOver: function onMouseOver() {
                        _this11.MouseOverCell(d[IdColoumn] + inhalt, d[k]);
                      },
                      onMouseLeave: function onMouseLeave() {
                        _this11.MouseLeaveCell(d[IdColoumn] + inhalt);
                      },
                      onClick: function onClick() {
                        _this11.Click(d[IdColoumn]);
                      } },
                    _react2.default.createElement(
                      'div',
                      null,
                      _react2.default.createElement('div', { className: "dataLabel", 'data-label': _this11.state.columns[_j] }),
                      _react2.default.createElement(
                        'div',
                        { className: "dataValue" },
                        d[k]
                      )
                    ),
                    _react2.default.createElement(
                      'span',
                      {
                        id: d[IdColoumn] + inhalt,
                        className: "CellComment" },
                      d[k]
                    )
                  );
                }),
                buttonsCol
              );
            } else {
              var _actionCol = null;
              var _j2 = -1;
              if (action !== null) {
                _actionCol = _react2.default.createElement(
                  'td',
                  null,
                  action
                );
              }
              var _buttonsCol = '';
              if (buttons.length > 0) {
                _buttonsCol = _react2.default.createElement(
                  'td',
                  {
                    className: "actionsButtons",
                    style: { 'width': widthButtons + "px" } },
                  _react2.default.createElement(
                    'table',
                    null,
                    _react2.default.createElement(
                      'tbody',
                      null,
                      _react2.default.createElement(
                        'tr',
                        {
                          onClick: function onClick() {
                            _this11.SelectRow(d[IdColoumn]);
                          },
                          key: 1 },
                        buttons
                      )
                    )
                  )
                );
              } else {
                _buttonsCol = _react2.default.createElement('td', {
                  className: "actionsButtons",
                  style: { 'width': widthButtons + "px" } });
              }
              return _react2.default.createElement(
                'tr',
                { id: d[IdColoumn] },
                _actionCol,
                _this11.state.keys.map(function (k) {
                  var inhalt = d[k];
                  if (!d[k]) {
                    inhalt = _i8;
                    _i8++;
                  }

                  _j2++;

                  return _react2.default.createElement(
                    'td',
                    {
                      id: "td" + d[IdColoumn] + inhalt,
                      key: k
                      // data-label={this.state.columns[j]}
                      , className: "pagingTableCell visibleTableContent",
                      onMouseOver: function onMouseOver() {
                        _this11.MouseOverCell(d[IdColoumn] + inhalt, d[k]);
                      },
                      onMouseLeave: function onMouseLeave() {
                        _this11.MouseLeaveCell(d[IdColoumn] + inhalt);
                      },
                      onClick: function onClick() {
                        _this11.Click(d[IdColoumn]);
                      } },
                    _react2.default.createElement(
                      'div',
                      null,
                      _react2.default.createElement('div', { className: "dataLabel", 'data-label': _this11.state.columns[_j2] }),
                      _react2.default.createElement(
                        'div',
                        { className: "dataValue" },
                        d[k]
                      )
                    ),
                    _react2.default.createElement(
                      'span',
                      {
                        id: d[IdColoumn] + inhalt,
                        className: "CellComment" },
                      d[k]
                    )
                  );
                }),
                _buttonsCol
              );
            }
          } else {
            var _actionCol2 = null;
            var _j3 = -1;
            if (action !== null) {
              _actionCol2 = _react2.default.createElement(
                'td',
                null,
                action
              );
            }
            var _buttonsCol2 = '';
            if (buttons.length > 0 || (typeof del === 'undefined' ? 'undefined' : _typeof(del)) === "object") {
              _buttonsCol2 = _react2.default.createElement(
                'td',
                {
                  className: "actionsButtons",
                  style: { 'width': widthButtons + "px" } },
                _react2.default.createElement(
                  'table',
                  null,
                  _react2.default.createElement(
                    'tbody',
                    null,
                    _react2.default.createElement(
                      'tr',
                      {
                        onClick: function onClick() {
                          _this11.SelectRow(d[IdColoumn]);
                        },
                        key: 1 },
                      buttons,
                      _react2.default.createElement(
                        'td',
                        { key: "del" },
                        del
                      )
                    )
                  )
                )
              );
            }
            return _react2.default.createElement(
              'tr',
              { id: d[IdColoumn] },
              _actionCol2,
              _this11.state.keys.map(function (k) {
                var inhalt = d[k];
                if (!d[k]) {
                  inhalt = _i8;
                  _i8++;
                }

                _j3++;

                return _react2.default.createElement(
                  'td',
                  {
                    id: "td" + d[IdColoumn] + inhalt,
                    key: k
                    // data-label={this.state.columns[j]}
                    , className: "pagingTableCell visibleTableContent",
                    onMouseOver: function onMouseOver() {
                      _this11.MouseOverCell(d[IdColoumn] + inhalt, d[k]);
                    },
                    onMouseLeave: function onMouseLeave() {
                      _this11.MouseLeaveCell(d[IdColoumn] + inhalt);
                    },
                    onClick: function onClick() {
                      _this11.Click(d[IdColoumn]);
                    } },
                  _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement('div', { className: "dataLabel", 'data-label': _this11.state.columns[_j3] }),
                    _react2.default.createElement(
                      'div',
                      { className: "dataValue" },
                      d[k]
                    )
                  ),
                  _react2.default.createElement(
                    'span',
                    {
                      id: d[IdColoumn] + inhalt,
                      className: "CellComment" },
                    d[k]
                  )
                );
              }),
              _buttonsCol2
            );
          }
        } else {

          if (download !== '') {
            if (d[IdColoumn].substring(0, 10) != 'NoDocument') {
              buttons.push(_react2.default.createElement(
                'td',
                { style: { float: 'left' }, key: "download" },
                download
              ));
            } else {
              buttons.push(_react2.default.createElement('td', null));
            }
            widthButtons += 45;
          }

          var _i9 = 0;
          var _actionCol3 = null;
          var _j4 = -1;
          if (action !== null) {
            _actionCol3 = _react2.default.createElement(
              'td',
              null,
              action
            );
          }
          var _buttonsCol3 = '';
          if (buttons.length > 0) {
            _buttonsCol3 = _react2.default.createElement(
              'td',
              {
                className: "actionsButtons",
                style: { 'width': widthButtons + "px" } },
              _react2.default.createElement(
                'table',
                null,
                _react2.default.createElement(
                  'tbody',
                  null,
                  _react2.default.createElement(
                    'tr',
                    {
                      onClick: function onClick() {
                        _this11.SelectRow(d[IdColoumn]);
                      },
                      key: 1 },
                    buttons
                  )
                )
              )
            );
          }

          return _react2.default.createElement(
            'tr',
            {
              key: d[IdColoumn],
              id: d[IdColoumn],
              onClick: _this11.props.onSelect ? _this11.props.onSelect.bind(_this11, d) : null },
            _actionCol3,
            _this11.state.keys.map(function (k) {
              var inhalt = d[k];
              if (!d[k]) {
                inhalt = _i9;
                _i9++;
              }

              _j4++;

              return _react2.default.createElement(
                'td',
                {
                  id: "td" + d[IdColoumn] + inhalt,
                  key: k
                  // data-label={this.state.columns[j]}
                  , className: "pagingTableCell visibleTableContent",
                  onMouseOver: function onMouseOver() {
                    _this11.MouseOverCell(d[IdColoumn] + inhalt, d[k]);
                  },
                  onMouseLeave: function onMouseLeave() {
                    _this11.MouseLeaveCell(d[IdColoumn] + inhalt);
                  },
                  onClick: function onClick() {
                    _this11.Click(d[IdColoumn]);
                  }
                  //title={d[k]}
                },
                _react2.default.createElement(
                  'div',
                  null,
                  _react2.default.createElement('div', { className: "dataLabel", 'data-label': _this11.state.columns[_j4] }),
                  _react2.default.createElement(
                    'div',
                    { className: "dataValue" },
                    d[k]
                  )
                ),
                _react2.default.createElement(
                  'span',
                  {
                    id: d[IdColoumn] + inhalt,
                    className: "CellComment" },
                  d[k]
                )
              );
            }),
            _buttonsCol3
          );
        }
      });

      var j = -1;
      var header = '';

      if (this.state.columns) {
        var actionCol = null;
        if (actionAll !== '') {
          actionCol = _react2.default.createElement(
            'th',
            {
              className: "action",
              style: { 'width': widthAction + 'px' } },
            actionAll
          );
        }
        {/*let buttonsCol = '';
          if(buttons.length>0 || typeof del == "object"){
           buttonsCol = <th 
               className={"actionsButtons"} 
             style={{ 'width':maxWidthButtons+'px' }} ></th>
          }*/}
        header = _react2.default.createElement(
          'tr',
          null,
          actionCol,
          this.state.columns.map(function (p) {

            j++;
            var cwidth = 120;
            if (_this11.state.CWidth) {
              cwidth = _this11.state.CWidth[j];
            }
            if (p === col) {
              return _react2.default.createElement(
                'th',
                {
                  style: { width: cwidth + 'px', cursor: 'pointer' },
                  key: p,
                  onClick: function onClick() {
                    _this11.SetOrder(p);
                  },
                  className: "tableHeaderHeader",
                  id: j },
                _react2.default.createElement(
                  'table',
                  null,
                  _react2.default.createElement(
                    'thead',
                    null,
                    _react2.default.createElement(
                      'tr',
                      null,
                      _react2.default.createElement(
                        'th',
                        { style: { paddingRight: '0px' }, className: "tableHeader" },
                        p
                      ),
                      _react2.default.createElement('th', { id: "ColIconArea_" + _this11.state.keys[j] })
                    )
                  )
                )
              );
            } else {
              if (_this11.state.SortColumns) {
                //Gibt es Spalten, die sortierbar sein sollen?
                for (var index = 0; index <= _this11.state.SortColumns.length; index++) {
                  if (_this11.state.SortColumns[index] == p) {
                    return _react2.default.createElement(
                      'th',
                      {
                        style: { width: cwidth + 'px', cursor: 'pointer' },
                        key: p,
                        onClick: function onClick() {
                          _this11.SetOrder(p);
                        },
                        className: "tableHeaderHeader",
                        id: j },
                      _react2.default.createElement(
                        'table',
                        null,
                        _react2.default.createElement(
                          'thead',
                          null,
                          _react2.default.createElement(
                            'tr',
                            null,
                            _react2.default.createElement(
                              'th',
                              { style: { paddingRight: '0px' }, className: "tableHeader" },
                              p
                            ),
                            _react2.default.createElement('th', { id: "ColIconArea_" + _this11.state.keys[j] })
                          )
                        )
                      )
                    );
                  }
                }
              }
              return _react2.default.createElement(
                'th',
                {
                  style: { width: cwidth + 'px' },
                  key: p,
                  className: "tableHeaderHeader",
                  id: j },
                _react2.default.createElement(
                  'table',
                  null,
                  _react2.default.createElement(
                    'thead',
                    null,
                    _react2.default.createElement(
                      'tr',
                      null,
                      _react2.default.createElement(
                        'th',
                        { style: { paddingRight: '0px' }, className: "tableHeader" },
                        p
                      ),
                      _react2.default.createElement('th', { id: "ColIconArea_" + _this11.state.keys[j] })
                    )
                  )
                )
              );
            }
          })
        );
      }

      var footer = '';
      if (this.state.Data.length > 0) {
        if (this.state.End === 0) {
          footer = _react2.default.createElement(
            'tr',
            null,
            _react2.default.createElement(
              'td',
              { className: "footerCell",
                colSpan: this.state.columns.length - 1,
                style: { float: 'right' } },
              _react2.default.createElement(
                'div',
                { className: "footerDiv", style: { float: 'right' } },
                _react2.default.createElement(
                  'table',
                  { className: "footerTable" },
                  _react2.default.createElement(
                    'tbody',
                    null,
                    _react2.default.createElement(
                      'tr',
                      null,
                      _react2.default.createElement(
                        'td',
                        null,
                        _react2.default.createElement(_PagingButton2.default, {
                          Width: 30,
                          onClick: function onClick() {
                            _this11.FirstPage();
                          },
                          text: _react2.default.createElement(_Icon2.default, {
                            AppURL: this.props.AppURL,
                            Name: "FirstPage",
                            Size: 18,
                            Color: "white",
                            Align: "left",
                            PaddingLeft: '6px',
                            PaddingTop: '1px' }),
                          Type: "Picker" })
                      ),
                      _react2.default.createElement(
                        'td',
                        null,
                        _react2.default.createElement(_PagingButton2.default, {
                          Width: 30,
                          onClick: function onClick() {
                            _this11.Previous();
                          },
                          text: _react2.default.createElement(_Icon2.default, {
                            AppURL: this.props.AppURL,
                            Name: "Left",
                            Size: 18,
                            Color: "white",
                            Align: "left",
                            PaddingLeft: '6px',
                            PaddingTop: '1px' }),
                          Type: "Picker" })
                      ),
                      _react2.default.createElement(
                        'td',
                        { id: "StartEndPage" },
                        this.state.Start,
                        ' - ',
                        this.state.End,
                        ' ',
                        this.props.LabelOf,
                        ' ',
                        this.state.Count
                      ),
                      _react2.default.createElement(
                        'td',
                        { id: "LabelPage" },
                        '( ',
                        this.state.LabelPage,
                        _react2.default.createElement('input', {
                          style: { width: '25px', marginRight: '5px' },
                          id: 'page',
                          className: 'page',
                          placeholder: this.Page(),
                          onKeyDown: function onKeyDown(event) {
                            if (event.keyCode === 13) {
                              _this11.ChangePage();
                            } else if (event.keyCode === 8 || event.keyCode === 46) {
                              document.getElementById("page").placeholder = '';
                            }
                          }
                        }),
                        ' ',
                        this.props.LabelOf,
                        ' ',
                        this.PageCount(),
                        ' )'
                      ),
                      _react2.default.createElement(
                        'td',
                        null,
                        _react2.default.createElement(_PagingButton2.default, {
                          Width: 30,
                          onClick: function onClick() {
                            _this11.Next();
                          },
                          text: _react2.default.createElement(_Icon2.default, {
                            AppURL: this.props.AppURL,
                            Name: "Right",
                            Size: 18,
                            Color: "white",
                            Align: "left",
                            PaddingLeft: '6px',
                            PaddingTop: '1px' }),
                          Type: "Picker" })
                      ),
                      _react2.default.createElement(
                        'td',
                        null,
                        _react2.default.createElement(_PagingButton2.default, {
                          Width: 30,
                          onClick: function onClick() {
                            _this11.LastPage();
                          },
                          text: _react2.default.createElement(_Icon2.default, {
                            AppURL: this.props.AppURL,
                            Name: "LastPage",
                            Size: 18,
                            Color: "white",
                            Align: "left",
                            PaddingLeft: '6px',
                            PaddingTop: '1px' }),
                          Type: "Picker" })
                      )
                    )
                  )
                )
              )
            )
          );
        } else {
          footer = _react2.default.createElement(
            'tr',
            null,
            _react2.default.createElement(
              'td',
              { className: "footerCell",
                colSpan: this.state.columns.length - 1,
                style: { float: 'right' } },
              _react2.default.createElement(
                'div',
                { className: "footerDiv", style: { float: 'right' } },
                _react2.default.createElement(
                  'table',
                  { className: "footerTable" },
                  _react2.default.createElement(
                    'tbody',
                    null,
                    _react2.default.createElement(
                      'tr',
                      null,
                      _react2.default.createElement(
                        'td',
                        null,
                        _react2.default.createElement(_PagingButton2.default, {
                          Width: 30,
                          onClick: function onClick() {
                            _this11.FirstPage();
                          },
                          text: _react2.default.createElement(_Icon2.default, {
                            AppURL: this.props.AppURL,
                            Name: "FirstPage",
                            Size: 18,
                            Color: "white",
                            Align: "left",
                            PaddingLeft: '6px',
                            PaddingTop: '1px' }),
                          Type: "Picker" })
                      ),
                      _react2.default.createElement(
                        'td',
                        null,
                        _react2.default.createElement(_PagingButton2.default, {
                          Width: 30,
                          onClick: function onClick() {
                            _this11.Previous();
                          },
                          text: _react2.default.createElement(_Icon2.default, {
                            AppURL: this.props.AppURL,
                            Name: "Left",
                            Size: 18,
                            Color: "white",
                            Align: "left",
                            PaddingLeft: '6px',
                            PaddingTop: '1px' }),
                          Type: "Picker" })
                      ),
                      _react2.default.createElement(
                        'td',
                        { id: "StartEndPage" },
                        this.state.Start + 1,
                        ' - ',
                        this.state.End,
                        ' ',
                        this.props.LabelOf,
                        ' ',
                        this.state.Count
                      ),
                      _react2.default.createElement(
                        'td',
                        { id: "LabelPage" },
                        '( ',
                        this.state.LabelPage,
                        ' ',
                        _react2.default.createElement('input', {
                          style: { width: '25px', marginRight: '5px', textAlign: 'center' },
                          id: 'page',
                          className: 'page',
                          placeholder: this.Page(),
                          onKeyDown: function onKeyDown(event) {
                            if (event.keyCode === 13) {
                              _this11.ChangePage();
                            } else if (event.keyCode === 8 || event.keyCode === 46) {
                              document.getElementById("page").placeholder = '';
                            }
                          } }),
                        this.props.LabelOf,
                        ' ',
                        this.PageCount(),
                        ' )'
                      ),
                      _react2.default.createElement(
                        'td',
                        null,
                        _react2.default.createElement(_PagingButton2.default, {
                          Width: 30,
                          onClick: function onClick() {
                            _this11.Next();
                          },
                          text: _react2.default.createElement(_Icon2.default, {
                            AppURL: this.props.AppURL,
                            Name: "Right",
                            Size: 18,
                            Color: "white",
                            Align: "left",
                            PaddingLeft: '6px',
                            PaddingTop: '1px' }),
                          Type: "Picker" })
                      ),
                      _react2.default.createElement(
                        'td',
                        null,
                        _react2.default.createElement(_PagingButton2.default, {
                          Width: 30,
                          onClick: function onClick() {
                            _this11.LastPage();
                          },
                          text: _react2.default.createElement(_Icon2.default, {
                            AppURL: this.props.AppURL,
                            Name: "LastPage",
                            Size: 18,
                            Color: "white",
                            Align: "left",
                            PaddingLeft: '6px',
                            PaddingTop: '1px' }),
                          Type: "Picker" })
                      )
                    )
                  )
                )
              )
            )
          );
        }
      } else {
        footer = _react2.default.createElement(
          'tr',
          null,
          _react2.default.createElement(
            'td',
            { className: "footerCell",
              colSpan: this.state.columns.length - 1,
              style: { float: 'right' } },
            _react2.default.createElement(
              'div',
              { className: "footerDiv", style: { float: 'right' } },
              _react2.default.createElement(
                'table',
                { className: "footerTable" },
                _react2.default.createElement(
                  'tbody',
                  null,
                  _react2.default.createElement(
                    'tr',
                    null,
                    _react2.default.createElement(
                      'td',
                      null,
                      _react2.default.createElement(_PagingButton2.default, {
                        Width: 30,
                        onClick: function onClick() {
                          _this11.FirstPage();
                        },
                        text: _react2.default.createElement(_Icon2.default, {
                          AppURL: this.props.AppURL,
                          Name: "FirstPage",
                          Size: 18,
                          Color: "white",
                          Align: "left",
                          PaddingLeft: '6px',
                          PaddingTop: '1px' }),
                        Type: "Picker" })
                    ),
                    _react2.default.createElement(
                      'td',
                      null,
                      _react2.default.createElement(_PagingButton2.default, {
                        Width: 30,
                        onClick: function onClick() {
                          _this11.Previous();
                        },
                        text: _react2.default.createElement(_Icon2.default, {
                          AppURL: this.props.AppURL,
                          Name: "Left",
                          Size: 18,
                          Color: "white",
                          Align: "left",
                          PaddingLeft: '6px',
                          PaddingTop: '1px' }),
                        Type: "Picker" })
                    ),
                    _react2.default.createElement(
                      'td',
                      { id: "StartEndPage" },
                      0,
                      ' - ',
                      0,
                      ' ',
                      this.props.LabelOf,
                      ' ',
                      0
                    ),
                    _react2.default.createElement('td', { id: "LabelPage" }),
                    _react2.default.createElement(
                      'td',
                      null,
                      _react2.default.createElement(_PagingButton2.default, {
                        Width: 30,
                        onClick: function onClick() {
                          _this11.Next();
                        },
                        text: _react2.default.createElement(_Icon2.default, {
                          AppURL: this.props.AppURL,
                          Name: "Right",
                          Size: 18,
                          Color: "white",
                          Align: "left",
                          PaddingLeft: '6px',
                          PaddingTop: '1px' }),
                        Type: "Picker" })
                    ),
                    _react2.default.createElement(
                      'td',
                      null,
                      _react2.default.createElement(_PagingButton2.default, {
                        Width: 30,
                        onClick: function onClick() {
                          _this11.LastPage();
                        },
                        text: _react2.default.createElement(_Icon2.default, {
                          AppURL: this.props.AppURL,
                          Name: "LastPage",
                          Size: 18,
                          Color: "white",
                          Align: "left",
                          PaddingLeft: '6px',
                          PaddingTop: '1px' }),
                        Type: "Picker" })
                    )
                  )
                )
              )
            )
          )
        );
      }

      if (this.state.Paging === false) {
        footer = _react2.default.createElement('div', null);
      }

      var controlClass = '';
      var headerClass = '';
      var pagingTooltip = '';
      if (this.state.Border === true) {
        controlClass = "pagingTable";
        headerClass = 'headerTable';
        pagingTooltip = _react2.default.createElement(
          'div',
          {
            className: 'PagingTooltip',
            style: { float: 'right', paddingTop: '11px' } },
          _react2.default.createElement(
            'table',
            null,
            _react2.default.createElement(
              'tbody',
              null,
              _react2.default.createElement(
                'tr',
                null,
                _react2.default.createElement(
                  'td',
                  null,
                  _react2.default.createElement('input', {
                    type: 'text',
                    id: 'search',
                    style: { lineHeight: '26px', color: 'black', fontFamily: 'Roboto, sans-serif', paddingLeft: '5px' } }),
                  ' ',
                  Tooltip
                ),
                _react2.default.createElement(
                  'td',
                  null,
                  _react2.default.createElement(_Icon2.default, {
                    Name: "Search",
                    Size: 24,
                    Color: "black",
                    Align: "left",
                    PaddingRight: '5px',
                    PaddingLeft: '6px',
                    PaddingTop: '1px',
                    OnClick: function OnClick() {
                      _this11.Search();
                    } })
                )
              )
            )
          )
        );
      } else {
        controlClass = "pagingTableWithoutBorder";
        headerClass = 'headerTableWithoutBorder';
        pagingTooltip = _react2.default.createElement(
          'div',
          {
            className: 'PagingTooltip',
            style: { float: 'right' } },
          _react2.default.createElement(
            'table',
            null,
            _react2.default.createElement(
              'tbody',
              null,
              _react2.default.createElement(
                'tr',
                null,
                _react2.default.createElement(
                  'td',
                  null,
                  _react2.default.createElement('input', {
                    type: 'text',
                    id: 'search',
                    style: { lineHeight: '26px', color: 'black', fontFamily: 'Roboto, sans-serif', paddingLeft: '5px' } }),
                  ' ',
                  Tooltip
                ),
                _react2.default.createElement(
                  'td',
                  null,
                  _react2.default.createElement(_Icon2.default, {
                    Name: "Search",
                    Size: 24,
                    Color: "black",
                    Align: "left",
                    PaddingRight: '5px',
                    PaddingLeft: '6px',
                    PaddingTop: '1px',
                    OnClick: function OnClick() {
                      _this11.Search();
                    } })
                )
              )
            )
          )
        );
      }

      var search = '';

      //Hier die Combobox ergänzen

      if (this.state.Search === true) {
        search = _react2.default.createElement(
          'table',
          null,
          _react2.default.createElement(
            'tbody',
            null,
            _react2.default.createElement(
              'tr',
              null,
              _react2.default.createElement(
                'th',
                { colSpan: columnCount },
                _react2.default.createElement(
                  'table',
                  null,
                  _react2.default.createElement(
                    'tbody',
                    null,
                    _react2.default.createElement(
                      'tr',
                      null,
                      _react2.default.createElement(
                        'td',
                        { style: { paddingTop: '10px' } },
                        _Vas2.default.getText("Labels", "Search")
                      ),
                      _react2.default.createElement(
                        'td',
                        { id: "PagingTableFilter", style: { paddingRight: '10px' } },
                        _react2.default.createElement(_SelectField2.default, {
                          AppURL: this.props.AppURL,
                          Id: "SearchParams",
                          ref: function ref(_ref) {
                            return _this11.ref = _ref;
                          },
                          IsRequired: false,
                          Data: this.SearchParamsArray,
                          Default: "Nachname" })
                      ),
                      _react2.default.createElement(
                        'td',
                        null,
                        pagingTooltip
                      )
                    )
                  )
                )
              )
            )
          )
        );
      }
      //#endregion        
      var paging = '';

      if (this.state.Paging === false) {
        paging = _react2.default.createElement('div', null);
      } else {

        var resultsPerPage = [{ Key: 5, Display: 5 }, { Key: 10, Display: 10 }, { Key: 15, Display: 15 }, { Key: 20, Display: 20 }, { Key: 50, Display: 50 }];

        if (this.state.ExtendShownResultsOnPage === true && this.state.ShowAllOnOnePage === false) {
          resultsPerPage = [{ Key: 5, Display: 5 }, { Key: 10, Display: 10 }, { Key: 15, Display: 15 }, { Key: 20, Display: 20 }, { Key: 50, Display: 50 }, { Key: 75, Display: 75 }, { Key: 100, Display: 100 }, { Key: 200, Display: 200 }];
        } else if (this.state.ExtendShownResultsOnPage === false && this.state.ShowAllOnOnePage === true) {
          resultsPerPage = [{ Key: 5, Display: 5 }, { Key: 10, Display: 10 }, { Key: 15, Display: 15 }, { Key: 20, Display: 20 }, { Key: 50, Display: 50 }, { Key: 9999999, Display: "Alle" }];
        } else if (this.state.ExtendShownResultsOnPage === true && this.state.ShowAllOnOnePage === true) {
          resultsPerPage = [{ Key: 5, Display: 5 }, { Key: 10, Display: 10 }, { Key: 15, Display: 15 }, { Key: 20, Display: 20 }, { Key: 50, Display: 50 }, { Key: 75, Display: 75 }, { Key: 100, Display: 100 }, { Key: 200, Display: 200 }, { Key: 9999999, Display: "Alle" }];
        }

        paging = _react2.default.createElement(_SelectField2.default, {
          AppURL: this.props.AppURL,
          SelectFieldChooseText: this.props.SelectFieldChooseText,
          Id: "Pages" + this.state.Id,
          Width: 103,
          Default: this.state.Limit,
          Label: this.props.LabelCountPerPage,
          Data: resultsPerPage,
          OnChange: function OnChange() {
            _this11.ChangeItemsPage();
          } });
      }

      var width = { width: 'auto' };
      if (this.props.Width) {
        width = { width: this.props.Width };
      }

      var tableBody = '';

      if (this.state.Filter === true) {
        var classNameBurgerMenue = "BurgerMenue";
        if (this.state.ShowIcons === false) {
          classNameBurgerMenue = "BurgerMenueLong";
        }
        if (this.state.Search === true) {
          tableBody = _react2.default.createElement(
            'tbody',
            null,
            _react2.default.createElement(
              'tr',
              null,
              _react2.default.createElement(
                'td',
                { style: { width: '40px' }, className: "tableHeaderPaging" },
                paging
              ),
              _react2.default.createElement('td', { id: "PagingTableGap", style: { width: '15%' } }),
              _react2.default.createElement(
                'td',
                { className: "search" },
                search
              ),
              _react2.default.createElement(
                'td',
                {
                  className: classNameBurgerMenue,
                  id: "burger" },
                menue
              )
            ),
            _react2.default.createElement(
              'tr',
              null,
              _react2.default.createElement(
                'td',
                { colSpan: 3 },
                _react2.default.createElement(
                  'div',
                  { id: "filterDiv", style: { float: "right" } },
                  filter
                )
              )
            )
          );
        } else {
          tableBody = _react2.default.createElement(
            'tbody',
            null,
            _react2.default.createElement(
              'tr',
              null,
              _react2.default.createElement(
                'td',
                { style: { width: '40px' }, className: "tableHeaderPaging" },
                paging
              ),
              _react2.default.createElement('td', { id: "PagingTableGap", style: { width: '15%' } }),
              _react2.default.createElement(
                'td',
                { colSpan: 3 },
                _react2.default.createElement(
                  'div',
                  { id: "filterDiv", style: { float: "right" } },
                  filter
                )
              ),
              _react2.default.createElement(
                'td',
                {
                  className: classNameBurgerMenue,
                  id: "burger" },
                menue
              )
            )
          );
        }
      } else {

        if (this.state.Search === true) {
          tableBody = _react2.default.createElement(
            'tbody',
            null,
            _react2.default.createElement(
              'tr',
              null,
              _react2.default.createElement(
                'td',
                { style: { width: '40px' }, className: "tableHeaderPaging" },
                paging
              ),
              _react2.default.createElement('td', { id: "PagingTableGap", style: { width: '15%' } }),
              _react2.default.createElement(
                'td',
                { className: "search" },
                search
              ),
              _react2.default.createElement(
                'td',
                {
                  className: "BurgerMenue",
                  id: "burger" },
                menue
              )
            )
          );
        } else {
          tableBody = _react2.default.createElement(
            'tbody',
            null,
            _react2.default.createElement(
              'tr',
              null,
              _react2.default.createElement(
                'td',
                { style: { width: '40px' }, className: "tableHeaderPaging" },
                paging
              ),
              _react2.default.createElement('td', { id: "PagingTableGap", style: { width: '15%' } }),
              _react2.default.createElement(
                'td',
                {
                  className: "BurgerMenue",
                  id: "burger" },
                menue
              )
            )
          );
        }
      }

      return _react2.default.createElement(
        'table',
        {
          style: width,
          id: this.state.Id,
          className: "pt" },
        _react2.default.createElement(
          'tbody',
          null,
          _react2.default.createElement(
            'tr',
            null,
            _react2.default.createElement(
              'td',
              null,
              _react2.default.createElement(
                'table',
                { className: headerClass },
                _react2.default.createElement('thead', null),
                tableBody
              )
            )
          ),
          _react2.default.createElement(
            'tr',
            null,
            _react2.default.createElement(
              'td',
              null,
              _react2.default.createElement(
                'table',
                { className: controlClass },
                _react2.default.createElement(
                  'thead',
                  null,
                  header
                ),
                _react2.default.createElement(
                  'tbody',
                  { id: "Data" },
                  dataSet
                ),
                _react2.default.createElement('tfoot', null)
              )
            )
          ),
          footer
        )
      );
    }
  }]);

  return PagingTable;
}(_react.Component);

exports.default = PagingTable;